var DataStore = /** @class */ (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    DataStore.prototype.getCampuses = function () {
        var campuses = this.json.campuses;
        return campuses.map(function (_a) {
            var id = _a.id, name = _a.name, value = _a.value;
            return ({ id: id, name: name, value: value });
        });
    };
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            var json = this.json;
            var programs = [];
            if (json.programs) {
                programs = json.programs;
                programs.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return programs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "ethnicity", {
        get: function () {
            return [
                { id: 1, value: "asian", label: "Asian" },
                { id: 2, value: "white", label: "White" },
                { id: 3, value: "hispanic", label: "Hispanic/Latino" },
                { id: 4, value: "black-african", label: "Black/African American" },
                { id: 5, value: "american-indian", label: "American Indian/Alaska Native" },
                { id: 6, value: "native-hawaiia", label: "Native Hawaiian/Pacific Islander" },
                { id: 7, value: "two-or-more", label: "Two or more races" },
                { id: 8, value: "unknown", label: "Race or Ethnicity unknown" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { id: 1, value: "single", label: "Single" },
                { id: 2, value: "married", label: "Married" },
                { id: 3, value: "divorced", label: "Divorced" },
                { id: 4, value: "widowed", label: "Widowed" },
                { id: 5, value: "separated", label: "Separated" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", name: "Male" },
                { value: "Female", name: "Female" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "relationShip", {
        get: function () {
            return [
                { id: 1, value: "Parent", label: "Parent" },
                { id: 2, value: "Guardian", label: "Guardian" },
                { id: 3, value: "Spouse", label: "Spouse" },
                { id: 4, value: "Partner", label: "Partner" },
                { id: 5, value: "Medical representative", label: "Medical representative" },
                { id: 6, value: "Power attorney", label: "Power attorney" },
                { id: 7, value: "Family", label: "Family" },
                { id: 8, value: "Other", label: "Other" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "citizenships", {
        get: function () {
            return [
                { id: 1, value: "us-citizen", label: "US Citizen" },
                { id: 2, value: "resident-alien", label: "Resident Alien" },
                { id: 3, value: "non-resident-alien", label: "Non-Resident Alien" },
                { id: 4, value: "asylum", label: "Asylum" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "suffixList", {
        get: function () {
            return [
                { label: "II", value: "II" },
                { label: "III", value: "III" },
                { label: "IV", value: "IV" },
                { label: "Jr.", value: "Jr." },
                { label: "MD", value: "MD" },
                { label: "P.E.", value: "P.E." },
                { label: "PHD", value: "PHD" },
                { label: "RN", value: "RN" },
                { label: "Sr.", value: "Sr." },
                { label: "V", value: "V" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    DataStore.prototype.getTotalCredits = function () {
        return this.json.totalCredits;
    };
    DataStore.prototype.getCampusesBySlug = function (slug) {
        var campusesBySlug = this.json[slug];
        if (!campusesBySlug) {
            var campus = this.json.default;
            return [
                {
                    id: campus.id,
                    name: campus.name,
                    code: campus.code,
                    address: campus.address,
                    state: campus.state,
                    phone: campus.phone,
                    school_code: campus.school_code
                }
            ];
        }
        return campusesBySlug.campuses.map(function (_a) {
            var id = _a.id, name = _a.name, code = _a.code, address = _a.address, state = _a.state, phone = _a.phone, school_code = _a.school_code;
            return ({
                id: id,
                name: name,
                code: code,
                address: address,
                state: state,
                phone: phone,
                school_code: school_code
            });
        });
    };
    DataStore.prototype.getProgramsBySlugAndCampusId = function (slug, campusId) {
        var campusesBySlug = this.json[slug];
        if (!campusesBySlug) {
            var program_1 = this.json.default.programs[0];
            return [
                {
                    id: program_1.id,
                    name: program_1.name,
                    code: program_1.name,
                    charge: program_1.charge,
                    quant_hours: program_1.quant_hours
                }
            ];
        }
        var campusIndexFound = campusesBySlug.campuses.findIndex(function (_a) {
            var id = _a.id;
            return campusId === id;
        });
        if (campusIndexFound > -1) {
            var programs = campusesBySlug.campuses[campusIndexFound].programs.map(function (_a) {
                var id = _a.id, name = _a.name, code = _a.code, charge = _a.charge, quant_hours = _a.quant_hours;
                return ({
                    id: id,
                    name: name,
                    code: code,
                    charge: charge,
                    quant_hours: quant_hours
                });
            });
            return programs;
        }
        var program = this.json.default.programs[0];
        return [
            {
                id: program.id,
                name: program.name,
                code: program.name,
                charge: program.charge,
                quant_hours: program.quant_hours
            }
        ];
    };
    DataStore.prototype.getSpfBySlugCampusIdAndProgramId = function (slug, campusId, programId) {
        var campusesBySlug = this.json[slug];
        if (!campusesBySlug || !campusId || !programId) {
            var program_2 = this.json.default.programs[0];
            return program_2.spfInfo;
        }
        var campusIndexFound = campusesBySlug.campuses.findIndex(function (_a) {
            var id = _a.id;
            return campusId === id;
        });
        if (campusIndexFound > -1) {
            var programIndexFound = campusesBySlug.campuses[campusIndexFound].programs.findIndex(function (_a) {
                var id = _a.id;
                return id === programId;
            });
            if (programIndexFound > -1) {
                var programFound = campusesBySlug.campuses[campusIndexFound].programs[programIndexFound];
                return programFound.spfInfo;
            }
            var program_3 = this.json.default.programs[0];
            return program_3.spfInfo;
        }
        var program = this.json.default.programs[0];
        return program.spfInfo;
    };
    return DataStore;
}());
export { DataStore };
//# sourceMappingURL=data:application/json;base64,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